export default __webpack_public_path__ + "static/media/043-lemon.e3feb04e.svg";